/**
 * Every failure in this package is an explicit, named error. Nothing here ever
 * returns a best-guess date: a wrong Bikram Sambat date does not crash anything,
 * it just quietly writes the wrong day onto a government file record and into a
 * tracking code a citizen keeps (ADR-0008).
 */
/** Base class, so a consumer can catch everything this package throws in one clause. */
export class NepaliDateError extends Error {
    constructor(message) {
        super(message);
        this.name = new.target.name;
    }
}
/**
 * The requested date is outside the range of the published calendar data we hold.
 * Never downgrade this to a fallback conversion — see README "Why the range is hard".
 */
export class BsRangeError extends NepaliDateError {
}
/** The date is structurally impossible (month 13, day 32, Ashadh 32 in a 31-day Ashadh, NaN). */
export class BsInvalidDateError extends NepaliDateError {
}
/** The tracking code does not match the ministry format. */
export class TrackingCodeError extends NepaliDateError {
}
//# sourceMappingURL=errors.js.map